<template>
  <div>
    <label v-if="label">{{ label }}</label>

    <v-date-picker :value="innerValue"
                   @input="updateValue"
                   v-if="!disabled">
      <e-text-input :value='props.inputValue'
                    @input='props.updateValue'
                    :disabled="disabled"
                    slot-scope='props'
                    ref="datePicker">
        <font-awesome-icon icon="calendar-alt" slot="prefix" />
      </e-text-input>
    </v-date-picker>

    <e-text-input :value="formattedValue" disabled v-if="disabled">
      <font-awesome-icon icon="calendar-alt" slot="prefix" />
    </e-text-input>

    <div class="invalid-feedback" v-if="hasErrors" v-html="errorMessage"></div>
  </div>
</template>

<script>
import moment from 'moment'
import { DatePicker } from 'mdbvue'

export default {
  components: {
    DatePicker
  },

  props: {
    value: {
      required: true
    },

    label: {
      type: String
    },

    minDate: {
      default: () => { return new Date(Date.now()) }
    },

    maxDate: {},

    disabled: {
      type: Boolean,
      default: false
    },

    errors: {
      default: null
    }
  },

  computed: {
    innerValue () {
      return moment(this.value).toDate()
    },

    formattedValue () {
      return moment(this.value).format('YYYY-MM-DD')
    },

    hasErrors () {
      return this.errors !== null && this.errors.length > 0
    },

    errorMessage () {
      return this.errors.join('<br>')
    }
  },

  methods: {
    updateValue (value) {
      const date = moment(value)

      if (date.isValid()) this.$emit('input', date.format('YYYY-MM-DD'))
      else this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/formFields/eDatePicker.vue